'use client'

import * as React from 'react'
import { useTranslations } from 'next-intl'

import { Button } from '@web/components/prod/button/button'

interface SubmissionConfirmationProps {
  onClose: () => void
  isPending: boolean
}

export function SubmissionConfirmation({ onClose, isPending }: SubmissionConfirmationProps) {
  const t = useTranslations('my_account.open_store_modal')

  return (
    <div className="text-center">
      <h3 className="mb-2 text-xl font-bold">{t('thank_you_title')}</h3>
      <p className="mb-5">
        {t.rich('thank_you_message.line1', {
          b: (chunks: React.ReactNode) => <b>{chunks}</b>,
        })}
      </p>
      <p className="mb-5">
        {t.rich('thank_you_message.line2', {
          b: (chunks: React.ReactNode) => <b>{chunks}</b>,
        })}
      </p>
      <Button
        type="button"
        variant="primary"
        className="w-full font-bold uppercase"
        onClick={onClose}
        disabled={isPending}
      >
        {t('confirmation_button')}
      </Button>
    </div>
  )
}
